export enum MeterSituation {
    TakeOverOpenMeters = 'takeOverOpenMeters',
    OpenClosedMeters = 'openClosedMeters',
    OpenNewMeters = 'openNewMeters',
    SupplierSwitch = 'supplierSwitch',
    Starter = 'starter',
}
